export enum AutogiroActionEnum {
  NoAction = 0,
  Cancel = 1,
}
